// extracted by mini-css-extract-plugin
module.exports = {"CodeBlock":"CodeBlock_CodeBlock__5ctHs","CodeBlock__label":"CodeBlock_CodeBlock__label__y57r1","CodeBlock__button":"CodeBlock_CodeBlock__button__TESET"};